import {useState} from 'react';
import { auth, db } from '../firebase';
import {signOut} from "firebase/auth";
import {getDoc, doc} from "firebase/firestore";
import {useHistory, Link} from "react-router-dom";
import cart from "../img/cart.svg";
import truck from "../img/truck.svg";
import heart from "../img/heart.svg";
import pic from "../img/user.svg";
import { useEffect } from 'react';
export default function Account({isUser, userProv, user}) {

  const history = useHistory();

    function logOut(){
        signOut(auth).then(() => {
            alert("Sign Out Sucessful. We Hope to see you soon💕.");
            history.push("/")
        })
    }

    const [userInfo, setUserInfo] = useState();

    useEffect(() => {
      if(userProv !== "google.com" && isUser){
        getDoc(doc(db, "users", user.uid)).then((item) => {
          setUserInfo(item.data())
        })
      }
    }, [user])


  return (
    <div>

        {userProv == "google.com" && isUser && <div className='account google-acc'>
          <div className='user-info'>
            <img src = {user.photoURL}/>
            <h3>{user.displayName}</h3>
            <button onClick={logOut}>Log out</button>
          </div>
          <div className='edit-info'>
            <Link to = "/cart"><img src = {cart}/>Shopping Cart</Link>
            <Link to = "/orders"><img src = {truck}/>Orders</Link>
            <Link to = "/wishlist"><img src = {heart}/>Wishlist</Link>
          </div>
        </div>}
        
        {isUser && userInfo && <div className='account email-acc'>
          <div className='user-info'>
            <img src = {userInfo.img}/>
            <h3>{userInfo.firstName +" "+ userInfo.lastName}</h3>
            <button onClick={logOut}>Log out</button>
          </div>
          <div className='edit-info'>
            <Link to = "/info"><img src = {pic}/>Edit Profile</Link>
            <Link to = "/cart"><img src = {cart}/>Shopping Cart</Link>
            <Link to = "/orders"><img src = {truck}/>Orders</Link>
            <Link to = "/wishlist"><img src = {heart}/>Wishlist</Link>
          </div>
        </div>}

    </div>
  )
}
